// extracted by mini-css-extract-plugin
module.exports = {"table":"StripedTable_table__1cnMd","summary":"StripedTable_summary__1c42C","summaryRow":"StripedTable_summaryRow__6Qv3C","summaryField":"StripedTable_summaryField__1y799"};